import { render } from "./BoletosAbertos.vue?vue&type=template&id=c1f7d336&ts=true"
import script from "./BoletosAbertos.vue?vue&type=script&lang=ts"
export * from "./BoletosAbertos.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/autoatendimento.totalvia.com.br/TotemAtendimento/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__